"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useProvisoApi = useProvisoApi;

var _react = require("react");

var _api = require("../api");

var _useContextProvider2 = require("./useContextProvider");

var _actions = require("../context/actions");

function useProvisoApi(adapter) {
  var _useContextProvider = (0, _useContextProvider2.useContextProvider)(),
      config = _useContextProvider.config,
      dispatch = _useContextProvider.dispatch;

  var userToken = config.userToken;
  var guid = config.guid;
  var api = (0, _react.useMemo)(function () {
    // Handle updated userToken from Proviso response
    var responseInterceptor = function responseInterceptor(res) {
      try {
        dispatch((0, _actions.initConfig)(userToken, guid));
      } catch (e) {}
    };

    return userToken && guid ? (0, _api.getProvisoApi)(userToken, guid, adapter, responseInterceptor) : null;
  }, [userToken, guid, adapter, dispatch]);
  return api;
}